import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/ranking', label: '排行榜' },
    { path: '/category', label: '分类' },
  ];

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span
              className={`text-2xl font-heading font-bold tracking-wide ${
                scrolled || !isHome ? 'text-primary-500' : 'text-white'
              }`}
            >
              女神漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.path
                    ? scrolled || !isHome
                      ? 'text-primary-500'
                      : 'text-white font-semibold'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}

            <Link
              to="/search"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              <i className="ri-search-line text-lg"></i>
            </Link>

            <Link
              to="/favorites"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              <i className="ri-bookmark-line text-lg"></i>
            </Link>

            <Link
              to="/history"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              <i className="ri-history-line text-lg"></i>
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium px-3 py-2 rounded-lg transition-colors ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-2 pt-2 border-t border-background-200/70">
              <Link
                to="/search"
                className="flex items-center gap-1.5 text-sm text-foreground-600 px-3 py-2 rounded-lg hover:text-primary-500 hover:bg-background-100 transition-colors"
              >
                <i className="ri-search-line"></i> 搜索
              </Link>
              <Link
                to="/favorites"
                className="flex items-center gap-1.5 text-sm text-foreground-600 px-3 py-2 rounded-lg hover:text-primary-500 hover:bg-background-100 transition-colors"
              >
                <i className="ri-bookmark-line"></i> 收藏
              </Link>
              <Link
                to="/history"
                className="flex items-center gap-1.5 text-sm text-foreground-600 px-3 py-2 rounded-lg hover:text-primary-500 hover:bg-background-100 transition-colors"
              >
                <i className="ri-history-line"></i> 历史
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}